// Theme preference handling with an "auto" mode that follows the OS setting.
const KEY = "force_theme";

export function getThemePref() {
    return localStorage.getItem(KEY) || "dark";
}

export function resolveTheme(pref) {
    if (pref === "auto") {
        return window.matchMedia && window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
    }
    return pref === "light" ? "light" : "dark";
}

export function applyTheme(pref) {
    const effective = resolveTheme(pref);
    const root = document.documentElement;
    root.classList.toggle("light", effective === "light");
    root.classList.toggle("dark", effective === "dark");
    localStorage.setItem(KEY, pref);
}

// Apply saved theme and keep "auto" in sync with the OS preference.
export function initTheme() {
    applyTheme(getThemePref());
    applyTextSize(getTextSize());
    if (window.matchMedia) {
        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
            if (getThemePref() === "auto") applyTheme("auto");
        });
    }
}

// Large-text accessibility setting: scales every rem-based size app-wide.
const TEXT_KEY = "force_text_size";
export const TEXT_SIZES = [["normal", "Normal"], ["large", "Large"], ["xl", "Extra large"]];

export function getTextSize() {
    return localStorage.getItem(TEXT_KEY) || "normal";
}

export function applyTextSize(size) {
    const root = document.documentElement;
    root.classList.remove("force-text-large", "force-text-xl");
    if (size === "large") root.classList.add("force-text-large");
    if (size === "xl") root.classList.add("force-text-xl");
    localStorage.setItem(TEXT_KEY, size);
}
